module.exports = __webpack_public_path__ + "img/Ankerdiebstahl.65e8411c.svg";